import React from 'react'
import Image from 'next/image'
import { getLink } from '@helpers/env'
import Badge, { BadgeProps } from '@components/ui/Badge'
import imageLoader from '@lib/imageLoader'
import styles from './styles.module.scss'

type CardImgProps = {
  badge?: BadgeProps
  title: string
  imgSrc: string
  link: string
  onClickHandler: (arg: string) => void
}

function CardImg({ badge, link, title, imgSrc, onClickHandler }: CardImgProps) {
  const linkClicked = () => onClickHandler('Image')

  return (
    <div className={styles.productBreakdownImage}>
      {!!link ? (
        <a
          className={styles.productBreakdownImage__link}
          href={getLink(link)}
          onClick={linkClicked}
        >
          <Image
            className={styles.productBreakdownImage__image}
            alt={title}
            width={287}
            height={287}
            src={imgSrc}
            loader={imageLoader}
          />
        </a>
      ) : (
        <div className={styles.productBreakdownImage__link}>
          {!!badge && (
            <div className={styles.productBreakdownImage__badge}>
              <Badge {...badge} fullWidth />
            </div>
          )}
          <Image
            className={styles.productBreakdownImage__image}
            alt={title}
            width={287}
            height={287}
            src={imgSrc}
            loader={imageLoader}
          />
        </div>
      )}
    </div>
  )
}

export default CardImg
